module.exports = __webpack_public_path__ + "img/feedback8.963f7adb.svg";